import { showToast } from '../../application/utils/toast.util';
import {client, clientAlderaan} from '../../core/stores';
import {ExerciseProps, InputEvent} from '../../application/types';
import {MUTATION_ALDERAAN_ACCOUNT, MUTATION_ACCOUNT} from '../../core/graphql/types';

export function MutationAccount(account: any, scope: any, setSubmitting: any, setProgress: any = null): Promise<any> {
  return new Promise((resolve,reject) => {
    const {name} = account;
    if(!name){
      showToast({html: 'Sua conta não pode ser salva sem um nome', displayLength: 5000} as any)
      reject(false);
      return false;
    }
    const mutationClient = scope === 'alderaan' ? clientAlderaan : client('account');
    const query = scope === 'alderaan' ? MUTATION_ALDERAAN_ACCOUNT : MUTATION_ACCOUNT;
    if(scope !== 'alderaan'){
      delete account.id;
      delete account.accountType;
      delete account.code;
      delete account.status;
      delete account.owner;
    }
    if(scope != 'alderaan') account.externalStoreFavorite = 'Stripe'
    if(account.accountBilling?.id){
      delete account.accountBilling.id;
      delete account.accountBilling.accountId;
      delete account.accountBilling.createdAt;
      delete account.accountBilling.updatedAt;
      delete account.accountBilling.__typename;
    }

    if (!!account.accountBilling && !account.accountBilling?.documentId) {
      account.accountBilling = undefined;
      delete account.accountBilling;
    }

    if (account.owner) {
      delete account.owner.__typename;
      Object.keys(account.owner).forEach((key) => {
        if ([null, undefined, ''].includes(account.owner[key])) {
          delete account.owner[key];
        }
      });
      if (account.owner.id) {
        account.owner = {id: String(account.owner.id)};
      }
      if (!account.owner.id && !account.owner.email) {
        delete account.owner;
      }
    }
    if(!(account.avatar instanceof File)) delete account.avatar;

    Object.keys(account).forEach( k => {
      if(typeof account[k] === 'number'){
       return account[k] = '' + account[k]; 
      }
    })

    mutationClient.mutate({
      mutation: query, 
      variables: account,
      context: {
        fetchOptions: {
          useUpload: true,
          onProgress: (ev: ProgressEvent) => {
            if(setProgress) setProgress(ev.loaded / ev.total)
          },
          onAbortPossible: (abortHandler: any) => {
          }
        }
      },
    })
    .then(response => {
      const {data} = response;
      const {updateAccount, createOrUpdateAccount} = data || {};
      const {account} = updateAccount || createOrUpdateAccount;
      showToast({html: 'Conta atualizada com sucesso!'});
      setSubmitting(false);
      resolve({status: 'success', account})
    })
    .catch( err => {
      console.log('ERROR ==> ', err)
      setSubmitting(false);
      const errorMessage = err.graphQLErrors.map((error) => error.message).join(',');
      showToast({ html: 'Houve um erro na sua solicitação.' })
      showToast({ html: errorMessage })
      reject({status: 'error', message: errorMessage})
    });
  })
}